<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $t("fnbWastage") }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="'edit-fnb-wastage/?fw_id=' + fnb_wastage.fw_id"
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="fnb-wastage"
          >{{ $tc("fnbWastage", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2"
                >{{ $tc("cinema", 1) }} {{ $t("name") }}</div
              >
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                selectedCinema
              }}</div>
            </div>
          </div>

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('concession', 1) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{selectedConcession}}</div>
            </div>
          </div> -->

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{
                $tc("sm_store_name", 1)
              }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                selectedStoreLevel
              }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{
                $tc("rawmaterials", 1)
              }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                selectedRawMaterial
              }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("quantity") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                selectedQuantity
              }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("uom") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ selectedUoM }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{
                $tc("reason", 1)
              }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                fnb_wastage.fw_reason
              }}</div>
            </div>
          </div>

          <!-- <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('accountableuser') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{selectedAccountableUser}}</div>
            </div>
          </div> -->

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{
                $t("approvedby")
              }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                selectedApprovedUser
              }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ "Final Amount" }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                currFormat(fnb_wastage.fw_fine_amount)
              }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("date") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{
                fnb_wastage.fw_date | dateparse
              }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{
                $tc("status", 1)
              }}</div>
              <div
                v-if="fnb_wastage.fw_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
                >{{ $t("active") }}</div
              >
              <div v-else class="col-md-9 col-lg-10 col-xl-10">{{
                $t("inactive")
              }}</div>
            </div>
          </div>

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{
                    $t("createdby")
                  }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ fnb_wastage.created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{
                    $t("createdat")
                  }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{
                      fnb_wastage.created_at | dateparse
                    }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{
                    $t("modifiedby")
                  }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ fnb_wastage.updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{
                    $t("modifiedat")
                  }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{
                      fnb_wastage.updated_at | dateparse
                    }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PosFnbService from "@/services/PosFnbService.js";
  import MasterService from "@/services/MasterService.js";

  export default {
    data() {
      return {
        fnb_wastage: {
          cinema_id: "",
          concession_level_id: "",
          rm_id: "",
          fw_quantity: "",
          uom_id: "",
          fw_reason: "",
          fw_accountable_user_id: "",
          fw_is_approved: "",
          fw_approved_by: "",
          fw_fine_amount: "",
          fw_date: "",
          fw_is_active: true,
          fw_is_approved: true,
          fw_id: "",
        },
        cinemas: [],
        concessionLevels: [],
        storeManagementsLevels: [],
        rawMaterials: [],
        UoMList: [],
        accountableUsers: [],
        users: [],
        selectedCinema: "Select Cinema",
        selectedConcession: "Select Concession",
        selectedStoreLevel: "Select Store",
        selectedRawMaterial: "Select Raw Material",
        selectedQuantity: "Select Quantity",
        selectedUoM: "Select UoM",
        selectedAccountableUser: "Select Accountable User",
        selectedApprovedUser: "Approved By",
      };
    },
    beforeMount() {
      this.fnb_wastage.fw_id = this.$route.query.fw_id;
    },
    mounted() {
      this.getFnbWastageDetails();
      // this.getCinemas();
      // this.getRawMaterials();
      // this.getUomList();
      // this.getUser();
    },
    methods: {
      getFnbWastageDetails: function() {
        let payload = {
          fw_id: this.fnb_wastage.fw_id,
          tableName: "fnb_wastage",
        };
        // PosFnbService.GetFnbWastageDetails(payload)
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              let obj = data.Records[0];
              this.fnb_wastage = obj;
              this.fnb_wastage.fw_date = new Date(obj.fw_date);
              this.selectedQuantity = obj.fw_quantity;
              this.getCinemas(obj.cinema_id);
              // this.getConcessionLevels(obj.cinema_id, obj.concession_level_id);
              this.getStoreManagementLevel(obj.cinema_id, obj.sm_id);
              this.getRawMaterials(obj.rm_id);
              this.getUomList(obj.uom_id);
              this.getApprovedUser(obj.fw_approved_by);
              this.getAccountableUser(obj.fw_accountable_user_id);
              this.getViewUsersDetails(obj.created_by, "created_by");
              this.getViewUsersDetails(obj.updated_by, "updated_by");
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getViewUsersDetails(user_id, key) {
        if (user_id) {
          MasterService.GetUserInfoById({ user_id })
            .then((response) => {
              const { data } = response;
              if (data && data.status && data.Records.length > 0) {
                this.fnb_wastage[key] = data.Records[0].user_name;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      },
      getUomList: function(uom_id) {
        let payload = {
          tableName: "ms_unit_of_measurement",
          uom_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.UoMList = data.Records;
              this.UoMList.map((x) => {
                if (x.uom_id == uom_id) {
                  this.selectedUoM = x.uom_unit;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getApprovedUser: function(user_id) {
        let payload = {
          tableName: "users",
          is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.users = data.Records;

              this.users.map((x) => {
                if ((x.role_id = 8 || x.role_id == "8")) {
                  this.accountableUsers.push(x);
                }
                if (x.user_id == user_id) {
                  this.selectedApprovedUser = x.first_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getAccountableUser: function(user_id) {
        let payload = {
          tableName: "users",
          is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.users = data.Records;
              this.users.map((x) => {
                if (x.user_id == user_id) {
                  this.selectedAccountableUser = x.first_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRawMaterials: function(rm_id) {
        let payload = {
          tableName: "ms_raw_materials",
          rm_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.rawMaterials = data.Records;
              this.rawMaterials.map((x) => {
                if (x.rm_id == rm_id) {
                  this.selectedRawMaterial = x.rm_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getCinemas: function(cinema_id) {
        let payload = {
          tableName: "ms_cinemas",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.cinemas = data.Records;
              this.cinemas.map((x) => {
                if (x.cine_id == cinema_id) {
                  this.selectedCinema = x.cine_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getConcessionLevels: function(cinema_id, concession_level_id) {
        this.concessionLevels = [];
        this.selectedConcession = "Select Concession";
        let payload = {
          tableName: "ms_concession_levels",
          cl_is_active: "Y",
          cinema_id: cinema_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.concessionLevels = data.Records;
              this.concessionLevels.map((x) => {
                if (x.cl_id == concession_level_id) {
                  this.selectedConcession = x.cl_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getStoreManagementLevel: function(cinema_id, sm_id) {
        this.storeManagementsLevels = [];
        this.selectedStoreLevel = "";
        let payload = {
          tableName: "store_management",
          sm_is_active: "Y",
          cinema_id: cinema_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.storeManagementsLevels = data.Records;
              this.storeManagementsLevels.map((x) => {
                if (x.sm_id == sm_id) {
                  this.selectedStoreLevel = x.sm_store_name;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      onSelectCinema: function(cinema) {
        this.selectedCinema = cinema.cine_name;
        this.fnb_wastage.cinema_id = cinema.cine_id;
        this.getConcessionLevels(cinema.cine_id);
      },
      onSelectConcessionLevel: function(concession) {
        this.selectedConcession = concession.cl_name;
        this.fnb_wastage.concession_level_id = concession.cl_id;
      },

      onSelectRawMaterial: function(rawmaterial) {
        this.selectedRawMaterial = rawmaterial.rm_name;
        this.fnb_wastage.rm_id = rawmaterial.rm_id;
      },

      onSelectUom: function(uom) {
        this.selectedUoM = uom.uom_unit;
        this.fnb_wastage.uom_id = uom.uom_id;
      },

      onSelectAccountableUser: function(user) {
        this.selectedAccountableUser = user.first_name;
        this.fnb_wastage.fw_accountable_user_id = user.user_id;
      },

      onSelectApprovedByUser: function(user) {
        this.selectedApprovedUser = user.first_name;
        this.fnb_wastage.fw_approved_by = user.user_id;
      },

      onResetForm: function() {
        this.fnb_wastage = {
          cinema_id: "",
          concession_level_id: "",
          rm_id: "",
          fw_quantity: "",
          uom_id: "",
          fw_reason: "",
          fw_accountable_user_id: "",
          fw_is_approved: "",
          fw_approved_by: "",
          fw_fine_amount: "",
          fw_date: "",
          fw_is_active: true,
        };
        this.selectedCinema = "Select Cinema";
        this.selectedConcession = "Select Concession";
        this.selectedQuantity = "Select Quantity";
        this.selectedUoM = "Select Uom";
      },
      onFinalSubmit: function(flag) {
        let payload = {
          ...this.fnb_wastage,
        };
        PosFnbService.UpdateFnbWastage(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.onResetForm();
              this.$router.push({
                path: "fnb-wastage",
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/viewFnbWastage.vue